import { Box, Skeleton, Typography, useMediaQuery, useTheme } from '@mui/material';

/**
 * Skeleton loading state for InvoiceDetails component.
 * Matches the layout of the actual invoice details view.
 */
const InvoiceDetailsSkeleton = () => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

	const renderFieldSkeleton = () => (
		<Box display="flex" flexDirection="column">
			<Skeleton width="60%" height={24} sx={{ mb: 0.5 }} />
			<Skeleton width="80%" height={20} />
		</Box>
	);

	if (isMobile) {
		return (
			<Box display="flex" flexDirection="column" gap={2} mt={1}>
				<Skeleton variant="text" width={200} height={40} />
				
				<Box>
					<Skeleton variant="text" width={150} height={32} sx={{ mb: 1 }} />
					{[...Array(6)].map((_, i) => (
						<Box key={i} mb={2}>
							{renderFieldSkeleton()}
						</Box>
					))}
				</Box>

				<Box>
					<Skeleton variant="text" width={180} height={32} sx={{ mb: 1 }} />
					{[...Array(5)].map((_, i) => (
						<Box key={i} mb={2}>
							{renderFieldSkeleton()}
						</Box>
					))}
				</Box>

				<Box>
					<Skeleton variant="text" width={150} height={32} sx={{ mb: 1 }} />
					<Skeleton variant="rectangular" height={300} />
				</Box>
			</Box>
		);
	}

	return (
		<Box>
			<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 4 }}>
				<Skeleton variant="text" width={250} height={48} />
			</Box>

			<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
				<Typography
					variant="h6"
					component="h4"
					sx={{ color: theme.palette.primary.main, fontWeight: 'bold' }}
				>
					Invoice Details
				</Typography>
			</Box>
			<Box display="grid" gridTemplateColumns="repeat(4, 1fr)" gap={2} mt={2}>
				{[...Array(8)].map((_, i) => (
					<Box key={i}>{renderFieldSkeleton()}</Box>
				))}
			</Box>

			<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 4 }}>
				<Typography
					variant="h6"
					component="h4"
					sx={{ color: theme.palette.primary.main, fontWeight: 'bold' }}
				>
					Billing Information
				</Typography>
			</Box>
			<Box display="grid" gridTemplateColumns="repeat(4, 1fr)" gap={2} mt={2}>
				{[...Array(6)].map((_, i) => (
					<Box key={i}>{renderFieldSkeleton()}</Box>
				))}
			</Box>

			<Box mt={4}>
				<Skeleton variant="text" width={150} height={32} sx={{ mb: 2 }} />
				<Skeleton variant="rectangular" height={400} />
			</Box>
		</Box>
	);
};

export default InvoiceDetailsSkeleton;
